module.exports = __webpack_public_path__ + "6b0999526f9216ee3fce0decf2f9aa0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/calendar.svg
// module id = 737
// module chunks = 0